






import BookingResourceCreateEdit from '../../../Templates/Admin/Booking/BookingResourceCreateEdit/BookingResourceCreateEdit.vue';

export default {
    name: 'CoAdminBookingResourceCreateEdit',
    components: {
        BookingResourceCreateEdit,
    },
    data() {
        return {};
    },
    computed: {
        isEditMode(): boolean {
            return !!this.$route.params.id;
        },
    },
};
